import * as Yup from "yup";

export function initialValues(classSchedule, initialDay, initialTime, initialEndTime) {
  return {
    courseTeacherId: classSchedule?.courseTeacherId || "",
    classroom: classSchedule?.classroom || "",
    scheduledDay: classSchedule?.scheduledDay || initialDay || "",
    startTime: classSchedule?.startTime?.substring(0, 5) || initialTime || "",
    endTime: classSchedule?.endTime?.substring(0, 5) || initialEndTime || "",
    notes: classSchedule?.notes || "",
    gradeId: classSchedule?.gradeId || "",
    academicCycleId: classSchedule?.academicCycleId || "",
  };
}

export function validationSchema() {
  return Yup.object({
    courseTeacherId: Yup.number().required("La asignación profesor-materia es obligatoria"),
    classroom: Yup.string().required("El aula es obligatoria"),
    scheduledDay: Yup.string()
      .required("El día de la semana es obligatorio"),
    startTime: Yup.string()
      .matches(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, "Formato de hora inválido (HH:MM)")
      .required("La hora de inicio es obligatoria"),
    endTime: Yup.string()
      .matches(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, "Formato de hora inválido (HH:MM)")
      .required("La hora de fin es obligatoria")
      .test("end-time-after-start", "La hora de fin debe ser posterior a la hora de inicio", function(endTime) {
        const { startTime } = this.parent;
        if (!startTime || !endTime) return true;
        return endTime > startTime;
      }),
    notes: Yup.string(),
    gradeId: Yup.number().required("El grado es obligatorio"),
    academicCycleId: Yup.number().required("El ciclo académico es obligatorio"),
  });
}